import React, { Component }  from 'react';
import Container from '../container/Container'
import {sideBarListItemsClerk} from '../component/Sidebar/SideBarItems'
import Panel from "../component/panel/Panel";
import './SuperAdminStyle.css'

export const SuperAdmin = () => {
    return (
        <section className="main-division">
            <Panel sideBarListItems={sideBarListItemsClerk}/>
            <Container/>
        </section>
    )
}
